import { motion } from "framer-motion";
import { Radio, ExternalLink } from "lucide-react";
import AudioPlayer from "@/components/AudioPlayer";

const RESIDENT = {
  name: "DJ MONSTRDROP",
  role: "RESIDENT DJ // MONSTR DROP",
  img: "/assets/monstrdrop-live.jpg",
  id: "monstrdrop",
};

export default function RadioSection() {
  return (
    <section id="radio" className="relative py-28 sm:py-36 bg-[#0C0C10] border-y border-[#22222B]" data-testid="radio-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="tech-corner border border-[#22222B] overflow-hidden group" data-testid="radio-flyer">
            <img
              src="/assets/select-saturdays-v2.jpg"
              alt="Select Saturdays radio show flyer"
              loading="lazy"
              className="w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-[#08080A] border border-[#22222B] p-3 w-28 sm:w-32">
            <img src="/assets/gcr-logo.jpg" alt="Green Coast Radio logo" loading="lazy" className="w-full object-contain" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="mono text-[11px] tracking-[0.35em] text-[#00F0FF] mb-4 flex items-center gap-3" data-testid="radio-eyebrow">
            <Radio className="h-3.5 w-3.5" />
            ON AIR // EVERY SATURDAY
          </p>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]" data-testid="radio-heading">
            SELECT <span className="text-[#CCFF00]">SATURDAYS</span>
          </h2>
          <p className="mt-6 text-sm sm:text-base text-[#A0A0AB] leading-relaxed max-w-lg" data-testid="radio-copy">
            Monstr Drop and Plagiarhythm present Select Saturdays on Green Coast Radio —
            resident DJ Monstrdrop at the decks, a weekly transmission of hand-picked
            records and special guest artists, streamed live from the coast. Same ear
            we use for A&R, on air every week.
          </p>

          <div className="mt-10">
            <div
              className="group relative overflow-hidden border border-[#22222B] aspect-[16/10] max-w-[420px]"
              data-testid={`radio-dj-${RESIDENT.id}`}
            >
              <img
                src={RESIDENT.img}
                alt={RESIDENT.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#08080A] via-transparent to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-4">
                <p className="mono text-[9px] tracking-[0.25em] text-[#00F0FF]">{RESIDENT.role}</p>
                <p className="font-display uppercase text-lg text-[#F2F2F5]">{RESIDENT.name}</p>
              </div>
            </div>
          </div>

          <div className="mt-10">
            <AudioPlayer
              src={`${process.env.REACT_APP_BACKEND_URL}/api/audio/follow-me-down.mp3`}
              title="FOLLOW ME DOWN — LIVE DJ CUT"
              kicker="LIVE FROM THE SELECT SATURDAYS ARCHIVE"
              testid="radio-audio-player"
            />
          </div>

          <a
            href="https://greencoastradio.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-8 inline-flex items-center gap-2 mono text-xs tracking-[0.2em] px-7 py-4 border border-[#00F0FF]/50 text-[#00F0FF] hover:bg-[#00F0FF] hover:text-black transition-colors duration-300"
            data-testid="radio-tunein-link"
          >
            TUNE IN — GREENCOASTRADIO.COM
            <ExternalLink className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
